<style>
	.item-img-page-show{
		opacity: 1;
		animation: show .3s ease-out;
		-webkit-animation: show .3s ease-out;
		overflow: hidden;
	}
	@keyframes show
	{
	  from {opacity: 0;}
	  to {opacity: 1;}
	}
	@-webkit-keyframes show
	{
	  from {opacity: 0;}
	  to {opacity: 1;}
	}
	.item-img-page-hide{
		opacity: 0;
		animation: hide .3s ease-in;
		-webkit-animation: hide .3s ease-in;
		}
	@keyframes hide
	{
	  from {opacity: 1;}
	  to {opacity: 0;}
	}
	@-webkit-keyframes hide
	{
	  from {opacity: 1;}
	  to {opacity: 0;}
	}

	.item-img-page {
		width:100%;
		height:100%;
		-webkit-flex: 1;
		flex: 1;
		z-index: 100;
		position: absolute;
		top:0;
		left:0;
		background-color:rgba(0,0,0,0.65);
		text-align: center;
	}
	.item-img-page .item-img-title {
		margin-top: 20px;
		text-align: center;
		color:#ddd;
	}
	.code-img-container img {
		overflow: hidden;
		position: absolute;
		/*top:50%;*/
		left:50%;
		transform:translate(-50%,-50%);
		/*border-radius: 10px;*/
		/*width:80%;*/
		/*height:45%;*/
		/*background-image: url("../assets/itemImg.png");*/
		background-repeat: no-repeat;
		background-size:100% 100%
	}
</style>
<template>
	<div  v-show="show" class="item-img-page" :class="{'item-img-page-show':animationShow, 'item-img-page-hide':!animationShow}" @click.self="close">
<!--		<div v-show = "imgTitleShow" class="item-img-title">{{imgTitle}}</div>
		<div class="item-img-container">
			<img :src= 'imgSrcUrl' alt="" @touchstart = 'touchstartImg' @touchmove = 'touchmoveImg' @touchend = 'touchendImg' :style="{'top':imgTop + 'px'}">
		</div>-->
		<div class="code-img-container">
			<img id="barcode" alt="" @touchstart = 'touchstartImg' @touchmove = 'touchmoveImg' @touchend = 'touchendImg' :style="{'top':imgTop + 'px'}">
		</div>
	</div>
</template>
<script>
import JsBarcode from 'jsbarcode'
export default {
	data () {
		let h = document.body.clientHeight
		return {
			halfPageHeight: h / 2,
			show: false,
			imgTitleShow: false,
			animationShow: false,
			imgTitle: '',
			imgSrcUrl: '',
			imgTop: 0,
			ImgScreenY: 0
		}
	},
	created () {
		this.imgTop = this.halfPageHeight
	},
	methods: {
		open (code) {
			this.createCode(code)
			this.show = true
			this.animationShow = true
		},
		close () {
			this.animationShow = false
			setTimeout(() => {
				this.show = false
				this.imgTop = this.halfPageHeight
				this.imgTitleShow = false
			}, 300)
		},
		touchstartImg (event) {
			this.ImgScreenY = event.touches[0].screenY
		},
		touchmoveImg (event) {
			let moveValue = event.touches[0].screenY - this.ImgScreenY
			moveValue *= 0.4
			moveValue = this.halfPageHeight + moveValue
			if (moveValue > this.halfPageHeight) {
				this.imgTop = this.halfPageHeight
			} else {
				this.imgTop = moveValue
			}
			if (this.imgTop < this.halfPageHeight) {
				this.imgTitle = '上滑关闭'
				this.imgTitleShow = true
			}
			if (this.imgTop < this.halfPageHeight * 0.73) {
				this.imgTitle = '释放关闭'
			}
		},
		touchendImg (event) {
			if (this.imgTop < this.halfPageHeight * 0.73) {
				this.close()
			} else {
				this.imgTop = this.halfPageHeight
				this.imgTitleShow = false
			}
		},
		createCode (code) {
			// JsBarcode('#barcode', code, {
			// 	format: 'pharmacode',
			// 	lineColor: '#0aa',
			// 	width: 4,
			// 	height: 40,
			// 	displayValue: true
			// })
			JsBarcode('#barcode', code)
		}
	}
}
</script>


// WEBPACK FOOTER //
// BarcodeImg.vue?409e86d5